<template>
	<div class="home-warp">
		<el-tabs :value="activeName" @tab-click="handleClick" class="el-tabs-diy">
			<!-- 清空原数据 -->
			<el-tab-pane label="凭证开具" name="1"><Issue v-if="activeName === '1'" :token="token"/></el-tab-pane>
			<el-tab-pane label="凭证利用" name="2"><Usetake v-if="activeName === '2'" :token="token"/></el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
// @ is an alias to /src
import Issue from "./Issue.vue";
import Usetake from "./Usetake.vue";

export default {
	name: "HomeView",
	components: { Issue, Usetake },
	props: {
		token: { type: String, default: "" }
	},
	data() {
		return {};
	},
	computed: {
		activeName() {
			return this.$store.getters.activeModel;
		}
	},
	watch: {
		activeName(newValue, oldValue) {
			// console.log("activeName newValue =============== ", newValue);
		}
	},
	methods: {
		handleClick(val) {
			this.$store.commit("SET_ACTIVEMODEL", val.name);
			this.$store.commit("SET_UPLOADSOURCE", false);
		}
	}
};
</script>

<style lang="scss" scoped>
.home-warp {
	width: 1200px;
	margin: 80px auto;

	h2 {
		margin: 80px 0;
		font-size: 28px;
		font-weight: 400;
		color: #242f44;
		line-height: 34px;
		text-align: center;
	}
}
</style>



// WEBPACK FOOTER //
// src/comm/components/document-conversion/electronicDec/index.vue